export const SYNC_ROOT = 'home';
export const APP_DATA_FOLDER = 'appData';
export const BASE_SYNC_FOLDER = 'Fabric';
export const MANIFEST_FOLDER = 'FabricSync';
export const CONFIG_FILE = MANIFEST_FOLDER + '/' + 'sync-config.json';

export const FABRIC_ITEM_SUFFIX = '.fabric';

export const SIZE_TOO_LARGE_ERROR = 'Size is too large';

export const DESKTOP_FILE_SYNC_MIN_VERSION = '0.2.2';
